// Custom Hooks
import { useModal } from "./use-modal";
// Components
import { UpgradeToProModal } from "../components/Modals/UpgradeToProModal";

export const useUpgradeToProModal = () => {
  const [onPresent, onDismiss] = useModal(<UpgradeToProModal />);
  return { onPresent, onDismiss };
};
